// Several rows at once: how many are chosen, one chip per state to move them all there,
// and a way out. Shown only while something is chosen.
import he from '../../i18n/he';
import Button from '../Button';
import { toneClass } from './ListGlance';

export default function ListBulkBar({ states, count, onState, onClear }) {
  return (
    <div className="list-bulk" role="toolbar" aria-label={he.lists.selected(count)}>
      <span className="list-bulk-count">{he.lists.selected(count)}</span>
      {states.map((s) => (
        <button key={s.id} type="button" className={`state-chip ${toneClass(s.tone)}`} onClick={() => onState(s.id)}>
          <span className="dot" />{s.label}
        </button>
      ))}
      <Button small variant="ghost" onClick={onClear}>{he.common.cancel}</Button>
    </div>
  );
}
